// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getCarLotsPending: false,
  getCarLotsError: null,
  car_lots: [],
  getBranchOfficesPending: false,
  getBranchOfficesError: null,
  getRolesPending: false,
  getRolesError: null,
  roles: [],
  getBusinessUnitsPending: false,
  getBusinessUnitsError: null,
  business_units: [],
  createUserPending: false,
  createUserError: null,
  getUsersPending: false,
  getUsersError: null,
  userList: [],
  usersPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  getUserByIdPending: false,
  getUserByIdError: null,
  getToolsByRolePending: false,
  getToolsByRoleError: null,
  updateUserPending: false,
  updateUserError: null,
  deleteUserPending: false,
  deleteUserError: null,
  sendUserConfirmationPending: false,
  sendUserConfirmationError: null,
  confirmUserPending: false,
  confirmUserError: null,
  updateUserPhoneNumberPending: false,
  updateUserPhoneNumberError: null,
  updateUserPasswordPending: false,
  updateUserPasswordError: null,
  editUser: null,
  getEditUserByIdPending: false,
  getEditUserByIdError: null,
  updateUserProfilePicturePending: false,
  updateUserProfilePictureError: null,
  deleteUserProfilePicturePending: false,
  deleteUserProfilePictureError: null,
};

export default initialState;
